import { render, staticRenderFns } from "./ModalAutorizarProcesso.vue?vue&type=template&id=1c9ff420&scoped=true"
import script from "./ModalAutorizarProcesso.vue?vue&type=script&lang=ts"
export * from "./ModalAutorizarProcesso.vue?vue&type=script&lang=ts"
import style0 from "./ModalAutorizarProcesso.vue?vue&type=style&index=0&id=1c9ff420&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9ff420",
  null
  
)

export default component.exports